const mapVisibilityCriterion = criterion => {
  return {
    id: criterion.id,
    internal_id: criterion.internal_id,
    name: criterion.name,
    description: criterion.description,
    is_used: criterion.is_used,
    block_uids: criterion.block_uids,
  }
}

export const transformResponseVisibilityCriteria = response => {
  return {
    results: response.results.map(mapVisibilityCriterion),
    count: response.count,
    next: response.next,
  }
}

export const transformRequestReorderVisibilityCriteria = ({ storeId, criteria }) => {
  return {
    storeId,
    criteria: criteria.map((criterion, index) => ({ id: criterion.id, position: index })),
  }
}
